import { useEffect, useState } from "react";
import { getOrderAnalytics } from "../../../services/OrderAnalytics";

export function useAnalyticsResource(section, { startDate, endDate }, mode = "all") {
  const [attempt, setAttempt] = useState(0);
  const [state, setState] = useState({ status: "loading" });
  const key = `${section}:${startDate}:${endDate}:${mode}:${attempt}`;

  useEffect(() => {
    const controller = new AbortController();
    getOrderAnalytics(section, { startDate, endDate, mode, signal: controller.signal }).then(
      (data) => {
        if (!controller.signal.aborted) setState({ key, status: "success", data });
      },
      () => {
        if (!controller.signal.aborted) setState({ key, status: "error" });
      },
    );
    return () => controller.abort();
  }, [section, startDate, endDate, mode, key]);

  return {
    ...(state.key === key ? state : { status: "loading" }),
    retry: () => setAttempt((value) => value + 1),
  };
}
